// Source
import * as Instance from "./Instance";
import * as ModelHelperSrc from "../model/HelperSrc";

export const loginBasic = (email: string, password: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        email,
        password
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/authentication/login_basic",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const activeDir = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/authentication/activedir", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const loginAd = (token: string, email: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        token,
        email
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/authentication/login_ad",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const logout = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/authentication/logout", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const clearApplication = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/authentication/clear_application", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
